import styled from 'styled-components';
import { SuiContainer, SuiButton } from '@splashthat/sui';

import { baseBorderRadius, containerPaddingXs, containerPaddingSm } from 'common/styles/variables';

export const NodeContainer = styled(SuiContainer).attrs({
    variation: 'border',
})`
    cursor: pointer;
    border-radius: ${baseBorderRadius};
    padding: ${containerPaddingSm};
    padding-top: ${containerPaddingXs};
    margin-top: ${({ marginTop = '0' }) => marginTop};
`;

const replaceSpaceWithDash = (qaId = '') => qaId.split(' ').join('-');

export const NodeButton = styled(SuiButton).attrs((props) => ({
    fullWidth: true,
    size: 'small',
    'data-qa': `WorkspaceSidebar-${replaceSpaceWithDash(props.qaId)}--button`,
}))`
    font-size: 1rem;
    font-weight: ${({ bold }) => (bold ? 'bold' : 'inherit')};

    & .SuiButton-label {
        text-align: left;
        padding: 0;
        color: ${({ theme }) => theme.palette.grayscale.black};

        &:hover {
            color: ${({ theme }) => theme.palette.primary.main};
        }
    }

    &:hover {
        border-color: inherit;

        & .SuiButton-label {
            color: ${({ theme }) => theme.palette.primary.main};
        }
    }

    &&&:not(.SuiButton--text) .SuiButton-content {
        padding: 0.625rem 0.5rem;
        padding-left: ${({ paddingLeft = '0.5rem' }) => paddingLeft};
    }

    & .SuiButton-icon-after {
        display: flex;
    }
`;
